import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

/**
 * Export data to a formatted PDF.
 * @param {Array} data - Table data.
 * @param {Array} columns - Table column definitions.
 * @param {string} title - Main title for the PDF.
 * @param {string} subtitle1 - Subtitle 1 (e.g., cancer names).
 * @param {string} subtitle2 - Subtitle 2 (e.g., district names).
 * @param {string} gender - Gender label ('Male', 'Female', 'Both').
 * @param {string} display - Display type ('population', 'Cancer', etc.).
 */
export const exportToPDF = (
  data,
  columns,
  // title = "",
  // subtitle1 = "",
  // subtitle2 = "",
  gender,
  display,
  footNote = "",
) => {
  if (!data || data.length === 0) {
    console.warn("No data to export");
    return;
  }
  const isASPR = display === "aspr";

  const doc = new jsPDF({
    orientation: "landscape",
    unit: "mm",
    format: isASPR ? "a3" : "a4",
  });

  const headers = columns.map((col) => {
    if (typeof col.exportHeader === "string") {
      return col.exportHeader;
    }

    if (typeof col.name === "string") {
      return col.name;
    }

    return "";
  });
  const body = data.map((row) =>
    columns.map((col) =>
      typeof col.selector === "function"
        ? col.selector(row)
        : row[col.selector],
    ),
  );
doc.setFontSize(10);
doc.setTextColor(40);
// doc.text(title, 10, 10);

doc.setFontSize(8);
// doc.text(subtitle1, 10, 16);
// doc.text(subtitle2, 10, 21);
  autoTable(doc, {
    head: [headers],
    body: body,
    startY: 25,
    styles: {
      fontSize: 8,
      cellPadding: 1,
      overflow: "linebreak",
      halign: "center",
    },

    headStyles: {
      fontSize: 7,
    },

    margin: {
      left: 5,
      right: 5,
    },
  });
const finalY = doc.lastAutoTable.finalY || 30;

if (footNote) {
  doc.setFontSize(8);

  const splitFootnote = doc.splitTextToSize(`NOTE: ${footNote}`, 260);

  doc.text(splitFootnote, 10, finalY + 10);
}


  const filename = `tncrp_${display}_${gender}_${new Date()
    .toISOString()
    .slice(0, 10)}.pdf`;

  doc.save(filename);
};
